import { LocaleKeys } from "src/internationalization/CustomIntlProvider";
import { OperatorCode } from "src/types/operator";

export const OPERATOR_CODE_LABELS: { [key in OperatorCode]: LocaleKeys } = {
  equalsCurrent: "page.rules.modal.create.linkedCase.form.operators.common.identifque",
  notEqualCurrent: "page.rules.modal.create.linkedCase.form.operators.common.different",
  empty: "page.rules.modal.create.linkedCase.form.operators.common.isNull",
  nonEmpty: "page.rules.modal.create.linkedCase.form.operators.common.isNotNull",
  greaterThanValue: "page.rules.modal.create.linkedCase.form.operators.numeric.greaterThan",
  greaterOrEqualThanValue:
    "page.rules.modal.create.linkedCase.form.operators.numeric.greaterThanOrEquals",
  lowerThanValue: "page.rules.modal.create.linkedCase.form.operators.numeric.lessThan",
  lowerOrEqualThanValue:
    "page.rules.modal.create.linkedCase.form.operators.numeric.lessThanOrEquals",
  contains: "page.rules.modal.create.linkedCase.form.operators.string.contains",
  notContains: "page.rules.modal.create.linkedCase.form.operators.string.notContains",
  isTrue: "page.rules.modal.create.linkedCase.form.operators.boolean.isTrue",
  notTrue: "page.rules.modal.create.linkedCase.form.operators.boolean.isFalse",
  equalsValue: "page.rules.modal.create.linkedCase.form.operators.common.equals",
  notEqualsValue: "page.rules.modal.create.linkedCase.form.operators.common.notEquals",
};
